export default {"src":"/_next/static/media/industrial-icon-selected.c35f71c7.svg","height":92,"width":129,"blurWidth":0,"blurHeight":0};